module.exports = __webpack_public_path__ + "h5/img/support.216fd948.png";